import { Component, Input } from "@angular/core";

import * as Highcharts from "highcharts/highstock";
import "highcharts/modules/exporting";

@Component({
  selector: "app-highcharts",
  templateUrl: "./highcharts.component.html",
  styleUrls: ["./highcharts.component.scss"],
})
export class HighchartsComponent {
  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options = {};
  @Input() updateChart = false;
  @Input() xAxisTitle = ""; // SG-7338
  @Input() height = "400px";
  @Input() marginTop = "20px";
  @Input() maximumPoints = 15;
  @Input() seriesType = "spline";
  @Input() totalLessionsSessions = 7;

  ngOnChanges() {
    this.dataLabelMapping["Total Lessons Sessions"] = this.totalLessionsSessions;
  }

  dataLabelMapping: { [key: string]: number } = {
    "Live Session": 6,
    "Average Lessons Duration": 4,
    "Total Lessons Sessions": this.totalLessionsSessions,
    "Total Cleared Lessons": 2,
    "Total Not Cleared Lessons": 9,
    "Total Voice Commands": 6,
    "Total Text Commands": 5,
    "Total Practice Set Sessions": 2,
    "Average Session Duration": 1,
    "Mastered Practice Sets": 3,
    "Average Missions Duration": 4,
    "Total Missions Sessions": 3,
    "Total Cleared Missions": 2,
    "Total Not Cleared Missions": 9,
    "Total Mastered Lessons": 3,
    "Session Played": 2,
    "Num. Of Users": 1,
    "Times Mastered": 3,
    "Correct Answer": 4,
    "Incorrect Answer": 2,
    "Incorrect Sessions": 9,
    "Total Sessions": 4,
    "Users": 3,
  };

  colors: string[] = [
    "rgb(112, 0, 152)",
    "rgb(215, 38, 61)",
    "rgb(45, 134, 86)",
    "rgba(30, 122, 175, 1)",
    "rgba(217, 32, 238, 1)",
    "rgba(120, 16, 190, 1)",
    "rgba(7, 155, 66, 1)",
    "rgba(210, 45, 65, 1)",
    "rgba(255, 86, 3, 1)",
  ];

  updateChartData(label: string[], dataset: any, isLiveSession = false) {
    console.log("updateChartData", dataset);
    let seriesData = [];
    let masteredMax = [];
    for (let index = 0; index < dataset.length; index++) {
      let obj = {
        name: dataset[index].label,
        type: this.seriesType,
        yAxis: 0,
        data: dataset[index].data,
        color: this.colors[this.dataLabelMapping[dataset[index].label] - 1],
      };

      masteredMax.push(Math.max(...dataset[index].data.map(Number)));
      seriesData.push(obj);
    }

    let overallMax = 0;
    for (let i = 0; i < masteredMax.length; i++) {
      // Get overall max Y value
      overallMax = Math.max(overallMax, masteredMax[i]);
    }

    // Optionally, round up to next multiple of 5 or 10 for better graph readability
    const yAxisMax = Math.ceil(overallMax / 10) * 10;

    let tickInterval = Math.ceil(yAxisMax / 5);
    if (tickInterval < 1) tickInterval = 1;

    this.chartOptions.chart = { type: "line" };
    this.chartOptions.title = { text: "" };
    this.chartOptions.series = seriesData;

    this.chartOptions.xAxis = {
      categories: label,
      min: 0,
      max: this.maximumPoints > label.length ? label.length : this.maximumPoints,
      scrollbar: {
        enabled: true,
        height: 7,
        barBackgroundColor: "grey",
        trackBorderRadius: 0,
      },
      labels: {
        rotation: 0,
        align: "center",
        step: 1,
        staggerLines: 1,
      },
      title: {
        text: this.xAxisTitle,
      },
    };

    this.chartOptions.yAxis = [
      {
        title: {
          text: "",
        },
        min: 0,
        max: yAxisMax,
        tickAmount: 5,
        tickInterval: tickInterval,
        labels: {
          format: "{value}",
        },
        visible: true,
        lineWidth: 1,
      },
    ];

    (this.chartOptions.plotOptions = {
      series: {
        ...(isLiveSession ? { stacking: "normal" } : {}),
      },
      line: {
        dataLabels: {
          enabled: true,
        },
        enableMouseTracking: false,
      },
    }),
      (this.chartOptions.responsive = {
        rules: [
          {
            condition: {
              maxWidth: 500,
            },
            chartOptions: {
              legend: {
                layout: "horizontal",
                align: "center",
                verticalAlign: "bottom",
              },
            },
          },
        ],
      });

    if (label.length <= 5 || label.length <= this.maximumPoints) {
      this.chartOptions.xAxis.max = label.length - 1;
      this.chartOptions.xAxis.scrollbar.enabled = false;
    }
  }
}
